import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/agencias`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/agencias/${id}`, options)
    .then(response => {
      let agencia = jsona.deserialize(response.data);
      delete agencia.links;
      return agencia;
    });
}

function add(agencia) {
  const payload = jsona.serialize({
    stuff: agencia,
    includeNames: null
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/agencias`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(agencia) {
  const payload = jsona.serialize({
    stuff: agencia,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/agencias/${agencia.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/agencias/${id}`, options);
}

function listActive(params) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios.get(`${url}/agencias/listActive`, options).then(response => {
    return {
      listActive: jsona.deserialize(response.data),
    };
  });
}

function listUser(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/agencias/usuarios/${id}`, options)
    .then(response => {
      return {
        listUser: jsona.deserialize(response.data),
      };
    });
}

export default {
  list,
  get,
  add,
  update,
  destroy,
  listActive,
  listUser
};

